import React, { useState } from 'react';
import { Row, Form, Col, Button, Table } from "react-bootstrap"
import { useDispatch, useSelector } from 'react-redux';
import TableComponent from './Table';
import { useHistory } from "react-router-dom";
import editForm from '../../api/editForm';
import { showToastAction } from '../../redux/toastSlice';

const initRow = { columnName: "", columnType: "date", columnLength: 0, page_number: 1, research_key: false, columnContent: [] }

const FormEdit = () => {
    const selectedProject = useSelector(state => state.selectedProject);
    const selectedForm = useSelector(state => state.selectedForm)
    const { form_name, description, template } = selectedForm;
    const [data, setData] = useState({ form_name, description, form_type: selectedForm.form_type });
    const [tableData, setTableData] = useState(Object.values(template));

    const history = useHistory()
    const dispatch = useDispatch()

    const updateData = (key, e) => {
        setData({ ...data, [key]: e.target.value })
    }

    const commitLater = async () => {
        var newtabledata = [];
        for (let index = 0; index < tableData.length; index++) {
            var newindex = 'Block' + (index + 1);
            newtabledata[newindex] = tableData[index];
        }
        
        try {
            await editForm(selectedProject.name, data.form_name, { ...newtabledata, description: data.description });
            dispatch(showToastAction({ message: "Form saved successfully", showToast: true, severity: "success" }))
            history.goBack()
        }
        catch (err) {
            dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
        }
    }

    return (
        <div className="container recent-activities">
            <Form>
                <div className="top-form-activities">
                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>Nom</Form.Label>
                        <Form.Control 
                            type="text" 
                            placeholder="Entrez le nom du formulaire" 
                            value={data.form_name} 
                            onChange={(e) => updateData("form_name", e)}
                            disabled
                        />
                    </Form.Group>
                    <Form.Group controlId="formBasicPassword">
                        <Form.Label>Description</Form.Label>
                        <Form.Control 
                            type="textarea" 
                            placeholder="Entrez la description du formulaire" 
                            value={data.description} 
                            onChange={(e) => updateData("description", e)} 
                        />
                    </Form.Group>
                    <Form.Group controlId="formBasicPassword">
                        <Form.Label>Type formulaire</Form.Label>
                        <Form.Control 
                            as="select" 
                            value={data.form_type} 
                            onChange={(e) => updateData("form_type", e)}
                            disabled
                        >
                            <option value="">Sélectionner le type</option>
                            <option value="archivage_document">Archivage de document</option>
                            <option value="insertion_donnees">Insertion de données</option>
                        </Form.Control>
                    </Form.Group>
                </div>

                <div className="table-section">
                    <TableComponent validated={selectedForm?.form_status === "VALIDATED"} data={tableData} setData={setTableData} />

                    <div className="text-right">
                        <Button
                            className="mt-3 mr-3"
                            variant="primary"
                            onClick={commitLater}
                        >
                            Valider
                        </Button>
                    </div>
                </div>
            </Form>
        </div>
    );
}

export default FormEdit;
